// @ts-nocheck

import { illustrations } from '../../../assets/img/betshare';
import { Locales } from '../../../types/common';
import { BetslipNotableCases } from '../../../types/history';

const {
  singe,
  chevre,
  irma,
  mortal_1,
  mortal_2,
  arbitre_1,
  arbitre_2,
  dab,
  mbappe,
  blessure,
  forgeron,
  lapin,
  ballon_bombe,
  indiana,
  lion,
  ultra,
  voleur,
  cibles,
  mymatch,
  poulpe,
  sage,
  astronaute,
  duel,
  footus,
  genie,
  telephone,
  zombie,
  pierre,
  pinceCashout,
  pinceLost,
  pincePig,
  pinceGold,
  // V2
  annule,
  bombe,
  casa_de_papel,
  catcheur,
  cote_killer_astronaute,
  echiquier,
  egypte,
  excalibur,
  hockey,
  main_de_dieu,
  man_of_mymatch,
  mortal_combo_genie,
  mymatch_en_cours,
  mymatch_perdu,
  piscine,
  raquette,
  surfeur,
  systeme_en_cours,
  systeme_gagnant,
  systeme_perdant,
  // V3
  basketteur,
  boxeur,
  boxeur_mortal_combo,
  cendrillon,
  cote_killer_casade_papel,
  formule1,
  halterophile,
  militaire,
  mission_impossible,
  mymatch_foot,
  // V4
  arretgoal,
  boucher,
  but,
  chevaltroie,
  dernierrempart,
  entraineur,
  goalpieuvre,
  golf,
  joueuror,
  marabout,
  marionnettes,
  numero9,
  renard,
  ski,
  supersub,
  tennis,
} = illustrations;

// Follow matrix of cases https://gitlab.dev.winamax.fr/betting-clients/winabet/wikis/betshare#image-matrix
const cases = {
  [BetslipNotableCases.SINGLE_RUNNING_LOW]: [
    astronaute,
    indiana,
    forgeron,
    lapin,
    irma,
    echiquier,
    excalibur,
    militaire,
    halterophile,
    mission_impossible,
    basketteur,
    arretgoal,
    chevaltroie,
    dernierrempart,
    goalpieuvre,
    golf,
    tennis,
    marionnettes,
    renard,
  ],
  [BetslipNotableCases.SINGLE_RUNNING_MIDDLE]: [
    astronaute,
    indiana,
    ballon_bombe,
    forgeron,
    irma,
    voleur,
    lapin,
    echiquier,
    excalibur,
    militaire,
    halterophile,
    mission_impossible,
    basketteur,
    arretgoal,
    chevaltroie,
    dernierrempart,
    goalpieuvre,
    golf,
    tennis,
    marionnettes,
    renard,
  ],
  [BetslipNotableCases.SINGLE_RUNNING_HIGH]: [
    ballon_bombe,
    duel,
    indiana,
    lapin,
    voleur,
    echiquier,
    excalibur,
    militaire,
    halterophile,
    mission_impossible,
    basketteur,
    arretgoal,
    chevaltroie,
    dernierrempart,
    goalpieuvre,
    golf,
    tennis,
    marionnettes,
    renard,
  ],
  [BetslipNotableCases.COMBO_RUNNING_LOW]: [
    astronaute,
    forgeron,
    lapin,
    irma,
    indiana,
    echiquier,
    excalibur,
    militaire,
    halterophile,
    mission_impossible,
    basketteur,
    arretgoal,
    chevaltroie,
    dernierrempart,
    goalpieuvre,
    golf,
    tennis,
    marionnettes,
    renard,
  ],
  [BetslipNotableCases.COMBO_RUNNING_MIDDLE]: [
    astronaute,
    ballon_bombe,
    irma,
    voleur,
    lapin,
    forgeron,
    indiana,
    echiquier,
    excalibur,
    militaire,
    halterophile,
    mission_impossible,
    basketteur,
    arretgoal,
    chevaltroie,
    dernierrempart,
    goalpieuvre,
    golf,
    tennis,
    marionnettes,
    renard,
  ],
  [BetslipNotableCases.COMBO_RUNNING_HIGH]: [
    ballon_bombe,
    duel,
    indiana,
    lapin,
    voleur,
    echiquier,
    excalibur,
    militaire,
    halterophile,
    mission_impossible,
    basketteur,
    arretgoal,
    chevaltroie,
    dernierrempart,
    goalpieuvre,
    golf,
    tennis,
    marionnettes,
    renard,
  ],
  [BetslipNotableCases.SYSTEM_RUNNING]: [systeme_en_cours],
  [BetslipNotableCases.MYMATCH_RUNNING]: [mymatch_en_cours],
  [BetslipNotableCases.SINGLE_WINNING_LOW]: [
    dab,
    footus,
    genie,
    sage,
    telephone,
    bombe,
    casa_de_papel,
    egypte,
    main_de_dieu,
    piscine,
    surfeur,
    boxeur,
    formule1,
    cendrillon,
    but,
    entraineur,
    joueuror,
    numero9,
    ski,
    supersub,
  ],
  [BetslipNotableCases.SINGLE_WINNING_MIDDLE]: [
    dab,
    footus,
    genie,
    sage,
    singe,
    mbappe,
    telephone,
    zombie,
    bombe,
    casa_de_papel,
    egypte,
    main_de_dieu,
    piscine,
    surfeur,
    boxeur,
    formule1,
    cendrillon,
    but,
    entraineur,
    joueuror,
    numero9,
    ski,
    supersub,
  ],
  [BetslipNotableCases.COTE_KILLER]: [lion, cote_killer_astronaute],
  [BetslipNotableCases.COMBO_WINNING_LOW]: [
    dab,
    footus,
    genie,
    sage,
    telephone,
    bombe,
    casa_de_papel,
    egypte,
    main_de_dieu,
    piscine,
    surfeur,
    boxeur,
    formule1,
    cendrillon,
    but,
    entraineur,
    joueuror,
    numero9,
    ski,
    supersub,
  ],
  [BetslipNotableCases.COMBO_WINNING_MIDDLE]: [
    footus,
    genie,
    telephone,
    zombie,
    singe,
    mbappe,
    dab,
    sage,
    bombe,
    casa_de_papel,
    egypte,
    main_de_dieu,
    piscine,
    surfeur,
    boxeur,
    formule1,
    cendrillon,
    but,
    entraineur,
    joueuror,
    numero9,
    ski,
    supersub,
  ],
  [BetslipNotableCases.MORTAL_COMBO]: [[mortal_1, mortal_2], mortal_combo_genie],
  [BetslipNotableCases.SYSTEM_WINNING]: [systeme_gagnant],
  [BetslipNotableCases.MYMATCH_LOW]: [mymatch, mymatch_foot],
  [BetslipNotableCases.MAN_OF_MYMATCH]: [man_of_mymatch],
  [BetslipNotableCases.SINGLE_LOST_LOW]: [
    [arbitre_1, arbitre_2],
    ultra,
    poulpe,
    blessure,
    pierre,
    pinceLost,
    catcheur,
    hockey,
    raquette,
    boucher,
    marabout,
  ],
  [BetslipNotableCases.SINGLE_LOST_OTHER]: [
    [arbitre_1, arbitre_2],
    cibles,
    pierre,
    poulpe,
    chevre,
    blessure,
    ultra,
    pinceLost,
    catcheur,
    hockey,
    raquette,
    boucher,
    marabout,
  ],
  [BetslipNotableCases.COMBO_LOST_ALL]: [
    [arbitre_1, arbitre_2],
    ultra,
    poulpe,
    chevre,
    pinceLost,
    catcheur,
    hockey,
    raquette,
    boucher,
    marabout,
  ],
  [BetslipNotableCases.COMBO_LOST_ONE]: [
    chevre,
    blessure,
    cibles,
    pierre,
    catcheur,
    hockey,
    raquette,
    boucher,
    marabout,
  ],
  [BetslipNotableCases.COMBO_LOST_OTHER]: [
    [arbitre_1, arbitre_2],
    chevre,
    blessure,
    cibles,
    pierre,
    poulpe,
    ultra,
    pinceLost,
    catcheur,
    hockey,
    raquette,
    boucher,
    marabout,
  ],
  [BetslipNotableCases.SYSTEM_LOST]: [systeme_perdant],
  [BetslipNotableCases.MYMATCH_LOST]: [mymatch_perdu],
  [BetslipNotableCases.CASHOUT_LOW]: [pincePig],
  [BetslipNotableCases.CASHOUT_HEROES]: [pinceGold],
  [BetslipNotableCases.CASHOUT_OTHER]: [pinceCashout],
  [BetslipNotableCases.CANCELLED]: [annule],
};

export const getIllustrations = (notableCase, lang) => {
  // Special case for langs #119401
  if (lang === Locales.ES || lang === Locales.EN || lang === Locales.DE) {
    if (notableCase === BetslipNotableCases.COTE_KILLER) {
      return [main_de_dieu, egypte];
    } else if (notableCase === BetslipNotableCases.MORTAL_COMBO) {
      return [singe, surfeur];
    }
  } else if (lang === Locales.FR) {
    // #125574
    if (notableCase === BetslipNotableCases.COTE_KILLER) {
      return cases[notableCase].concat([cote_killer_casade_papel]);
    } else if (notableCase === BetslipNotableCases.MORTAL_COMBO) {
      return cases[notableCase].concat([boxeur_mortal_combo]);
    }
  }
  return cases[notableCase];
};
